const routes = [
  {
    path: '/withdraw',
    name: 'Withdraw',
    meta: { layout: 'default', menu: 'withdraw', requiresAuth: true },
    component: () => import('@/pages/withdraw/WithdrawView.vue')
  }
]

export default routes
